import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EventsPage } from './events';

@NgModule({
  declarations: [
    EventsPage,
  ],
  imports: [
    IonicPageModule.forChild(EventsPage),
  ],
  entryComponents: [
    EventsPage
  ]
})
export class EventsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/events/events.module.ts